module.exports = __webpack_public_path__ + "static/img/icon-logo.bb926400.png";